<template>
    <b-row class="d-flex align-items-center m-0">
      <b-col cols="12" lg="5" class="px-5 d-flex align-items-center align-self-stretch header-content">
        <div class="overlay"></div>      

        <div class="content">
          <div class="w-100 mb-4">    
            <b-img fluid src="@/assets/logos/logo.svg" class="mb-3" alt="KILX: Stratégies d'affaires numériques" />

            <h1 class="slogan bold display-5 text-white">
              Le monde est numérique <span class="blinking-cursor blue">_</span>
            </h1>
          </div>
          
          <div class="d-flex justify-content-around">
            <b-button 
              href="https://www.google.ca/maps/place/2520+Rue+King+Ouest,+Sherbrooke,+QC+J1J+2E8/@45.3982867,-71.9336414,17z/data=!4m13!1m7!3m6!1s0x4cb7b49ff126d68f:0x53b75ca8bae57719!2s2520+Rue+King+Ouest,+Sherbrooke,+QC+J1J+2E8!3b1!8m2!3d45.3979378!4d-71.9336447!3m4!1s0x4cb7b49ff126d68f:0x53b75ca8bae57719!8m2!3d45.3979378!4d-71.9336447?hl=fr&authuser=0" 
              class="d-flex align-items-center justify-content-center fab fab-sm" 
              v-b-tooltip.hover 
              title="Venez nous voir en personne"
              target="_blank"
            >
              <font-awesome-icon icon="map-marked" size="2x" />
            </b-button>
            
            <b-button 
              href="tel:18195653006"
              class="d-flex align-items-center justify-content-center fab fab-sm" 
              v-b-tooltip.hover 
              title="819.565.3006"
            >
              <font-awesome-icon icon="phone-square-alt" size="2x" />
            </b-button>

            <b-button
              class="d-flex align-items-center justify-content-center fab fab-sm" 
              v-b-tooltip.hover 
              title="Rejoignez-nous sur LinkedIn"
              href="https://www.linkedin.com/company/la-cartoucherie/"
              target="_blank"
            >
              <font-awesome-icon :icon="['fab', 'linkedin']" size="2x" />
            </b-button>
            
            <b-button 
              class="d-flex align-items-center justify-content-center fab fab-sm" 
              @click="showYoutube()" 
              v-b-tooltip.hover 
              title="Visitez notre chaîne Youtube"
              target="_blank"
            >
              <font-awesome-icon :icon="['fab', 'youtube']" size="2x" />
            </b-button>
          </div>
        </div>          
      </b-col>

      <b-col cols="12" lg="7" class="p-5">
        <b-form @reset="reset" @submit.prevent="submit" v-if="show" class="">
          <div v-if="!loading && !message.show">
            <b-form-group id="nameGroup" label="Nom:" label-for="name">
              <b-form-input
                id="name"
                type="text"
                v-model="form.name"
                required
                placeholder="Entrez votre nom complet" 
                :formatter="nameFormatter"
                :state="nameValidation"
              />
            </b-form-group>

            <b-form-group id="emailGroup" label="Courriel:" label-for="email">
              <b-form-input
                id="email"
                type="email"
                v-model="form.email"
                required
                placeholder="Entrez votre courriel" 
                :formatter="emailFormatter"
                :state="emailValidation"
              />
            </b-form-group>

            <b-form-group id="phoneGroup" label="Téléphone:" label-for="phone">
              <b-form-input
                id="phone"
                type="tel"
                v-model="form.phone"
                placeholder="Entrez votre numéro de téléphone"
                :formatter="phoneFormatter"
                :state="phoneValidation"
              />
            </b-form-group>

            <b-form-group id="urlGroup" label="Site web:" label-for="url">
              <b-form-input
                id="url"
                type="text"
                v-model="form.url"
                placeholder="Entrez l'adresse du site web de votre entreprise"
                :formatter="urlFormatter"
                :state="urlValidation"
              />
            </b-form-group>

            <b-form-group id="subjectGroup" label="Sujet:" label-for="subject">
              <b-form-select id="subject" v-model="form.subject" :options="subjects"></b-form-select>
            </b-form-group>

            <b-form-group id="textGroup" label="Message:" label-for="text">
              <b-form-textarea
                id="text"
                v-model="form.text"
                placeholder="Entrez votre message"
                rows="5"
                max-rows="20"
                required
              ></b-form-textarea>
            </b-form-group>
          </div>

          <div v-if="loading" class="d-flex justify-content-center mb-3">
            <b-spinner label="Envoi..." ></b-spinner>
          </div>

          <b-row>
            <b-col>
              <b-button 
                type="reset" 
                variant="danger" 
                class="w-100 mb-2" 
                v-if="!loading && !message.show"
              >
                <font-awesome-icon icon="times" size="lg" class="mr-2"/>Annuler
              </b-button>
            </b-col>

            <b-col>
              <b-button                 
                type="submit"
                variant="success" 
                class="w-100 mb-2" 
                v-if="!loading && !message.show"
                :disabled="invalidForm"
              >
                <font-awesome-icon icon="paper-plane" size="lg" class="mr-2"/>Envoyer
              </b-button>
            </b-col>
          </b-row>

          <b-alert 
            :variant="message.style" 
            dismissible 
            :show="message.show" 
            @dismissed="closeModal"
          >
            <h3>{{ message.content }}</h3>
          </b-alert>
          
        </b-form>
      </b-col>
    </b-row>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Contact',
  props: [
    'showModal',
    'msg'
  ],
  data() {
    return {
      base: process.env.BASE_URL,
      show: true,
      loading: false,
      form: {
        name: null,
        email: null,
        phone: null,
        url: null,
        subject: 0,
        text: null
      },
      subjects: [
          { value: 0, text: `Choisir un sujet`, disabled: true },
          { value: 1, text: `Demande d'information générale` },
          { value: 2, text: `Demande de consultation` },
          { value: 3, text: `Demande de démonstration` }
      ],
      message: {
        show: false,
        style: 'primary',
        content: ''
      }
    }
  },
  mounted() {
    if(this.msg && this.msg.subject) {
      this.form.subject = this.msg.subject
    }
  },
  computed: {
    urlValidation() {
        let pattern =/^[A-z0-9-_\.:/]*$/

        if (this.form.url) return this.runTest(this.form.url, pattern)
    },
    nameValidation() {
        let pattern =/^['A-z-\s\u00C0-\u017F]*$/
        
        if (this.form.name) return this.runTest(this.form.name, pattern)
    },
    emailValidation() {
        let pattern =/^[\da-z\.-_]{2,150}@[\da-z\.-_]{2,150}\.([\da-z]{2,5})$/
        
        if (this.form.email) return this.runTest(this.form.email, pattern)
    },
    phoneValidation() {
        let pattern =/^[(][0-9]{3}[)]\s[0-9]{3}[-][0-9]{4}$/
        
        if (this.form.phone) return this.runTest(this.form.phone, pattern)
    },
    invalidForm() {
      if (
        (this.nameValidation && this.nameValidation !== null) &&
        (
          (this.emailValidation && this.emailValidation !== null) ||
          (this.phoneValidation && this.phoneValidation !== null)
        )
      ) {
        return false
      }
      
      return true
    }
  },
  methods: {
    runTest(field, pattern) {        
      if (field !== ``) {
          return pattern.test(field)
      }

      return null
    },
    urlFormatter(string) {
      return string.replace(/[^0-9A-z\.-_/:]/g, '')
    },
    phoneFormatter(string) {
      string = string
        .replace(/[^\d]/g, "")
        .replace(/^1/, "")
        .substring(0, 10);
      return (
        "(" +
        string.substring(0, 3) +
        ") " +
        string.substring(3, 6) +
        "-" +
        string.substring(6, 10)
      )
    },
    emailFormatter(string) {
        return string.toLowerCase()
    },
    nameFormatter(string) {
      let parts = [];

      if(string) {
        parts = string.split(" ");

        let nbParts = parts.length;

        if (nbParts > 1) {
          for (let p in parts) {
            if (typeof parts[p] === "string") {
              parts[p] = this.nameCapitalizer(parts[p])
            }
          }
          return parts.join(" ");
        } else {
          return this.nameCapitalizer(string)
        }
      }
    },
    nameCapitalizer(string) {
      let parts = [];

      parts = string.split("-");

      let nbParts = parts.length;

      if (nbParts > 1) {
        for (let p in parts) {
          if (typeof parts[p] === "string") {
            parts[p] = parts[p].replace(/[^'\sA-Za-z\u00C0-\u017F]/g, "");
            parts[p] =
              parts[p].substring(0, 1).toUpperCase() +
              parts[p].substring(1, parts[p].length).toLowerCase();
          }
        }
        return parts.join("-");
      } else {
        parts[0] = parts[0].replace(/[^'\sA-z\u00C0-\u017F-]/g, "");
        parts[0] =
          parts[0].substring(0, 1).toUpperCase() +
          parts[0].substring(1, parts[0].length).toLowerCase();

        return parts[0];
      }
    },
    submit() {
      this.loading = true

      axios.post(this.base + '/api/contact', this.form)
        .then(response => {
          this.loading = false
          this.message = {
            show: true,
            style: 'success',
            content: 'Votre message a été envoyé avec succès. Nous vous reviendrons sous peu.'
          }
        })
        .catch(e => {
          this.message = {
            show: true,
            style: 'danger',
            content: `Une erreur est survenue durant l'envoi du message. Veuillez nous téléphoner ou réessayer plus tard.`
          }
          this.loading = false
          this.errors.push(e)
        })
    },
    onReset(evt) {
      evt.preventDefault()
      reset()
    },
    closeModal() {
      this.$emit('closeModal')
      this.reset()
    },
    reset() {
      this.form = {
        name: null,
        email: null,
        phone: null,
        subject: null,
        text: null
      }
      this.show = false
      this.message = {
        show: false,
        style: '',
        content: ''
      }
      this.$nextTick(() => {
        this.show = true
      })
      this.$emit('closeModal')
      console.log()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header-content,
.header-content > .content {
  position: relative;
  z-index: 10;
}

.header-content {
  position: relative;
  background: url("../assets/images/code.jpg") no-repeat center fixed;
  background-size: cover;
  padding: 3vh 0;
}

.overlay {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 1;
  background-color: rgba(0,0,0,0.9);
}

.form-control,
input {
    color: #001216;
}

</style>
